import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebSocketAudioService {

  constructor() { }

  playSound(sound: string) {
    let audio = new Audio();
    audio.src = `assets/sounds/${sound}`;
    audio.load();
    audio.play();
    audio.remove();
  }
}
